import type { CastProfile } from './castProfiles.ts'
import type { CastProfileTimeline } from './castProfileTimelines.ts'

// Separate researched follow-up to the published C44 batch, reviewed October 1, 2026.
// Hunt newcomer introductions are not established couple romances.
// Interaction-only links and unknown current outcomes remain explicit.
export const researchedProfilesCFollowup: CastProfile[] = [
  {
    "personId": "p-sierra-90-day-hunt-for-love-s1",
    "headline": "A fresh face entering the retreat, with romance on the agenda and no old franchise couple to untangle.",
    "bio": [
      "Sierra Perryman introduced herself to Axios in 2025 as a Charlotte real-estate professional who also bartended on weekends. She joined the show hoping for romance and new connections.",
      "TLC introduced her among Hunt for Love’s new singles rather than as a returning alum with an established televised partner. Her first franchise chapter was a chance to meet people in Tulum—the dating pool now came with an actual pool."
    ],
    "originStory": "Sierra entered Hunt for Love Season 1 as a new single at the Tulum retreat, not through a previously featured international couple.",
    "journeys": [
      {
        "label": "Where it started: a singles-retreat debut",
        "era": "Hunt for Love S1",
        "summary": "Sierra entered the franchise independently as a new retreat single. The checked sources do not establish a named on-show partner or current relationship outcome."
      }
    ],
    "sources": [
      {
        "label": "Axios Charlotte: Sierra’s direct interview",
        "url": "https://www.axios.com/local/charlotte/2025/06/07/charlotte-woman-stars-in-tlc-s-new-dating-show"
      },
      {
        "label": "TLC: Hunt for Love’s new singles",
        "url": "https://www.tlc.com/shows/90-day-hunt-for-love/meet-the-90-day-hunt-for-love-singles-retreat-hopefuls"
      },
      {
        "label": "Us Weekly: Hunt for Love’s retreat format",
        "url": "https://www.usmagazine.com/entertainment/news/90-day-hunt-for-love-sneak-peek-rob-finds-love-at-first-sight/"
      }
    ]
  },
  {
    "personId": "p-shelby-90-day-hunt-for-love-s1",
    "headline": "Houston’s Dr. C tries a dating retreat—a very different kind of group activity.",
    "bio": [
      "Shelby Calabrese came to Hunt for Love with a life in education, not a previous 90 Day couple storyline. Local reporting identified her as a former Houston elementary-school principal whom students knew as Dr. C.",
      "TLC placed her among the new singles joining the Tulum retreat. The format offered dates and mixers instead of a classroom timetable; her earlier career helps tell us who she is, but it does not prove whom she ultimately chose."
    ],
    "originStory": "Shelby was introduced as a new single on Hunt for Love Season 1. Chron linked the retreat participant’s identity to Houston educator Shelby Calabrese.",
    "journeys": [
      {
        "label": "Where it started: a new single in Tulum",
        "era": "Hunt for Love S1",
        "summary": "Shelby joined independently to participate in the singles-retreat format. No checked direct source establishes a lasting filmed relationship or current partner."
      }
    ],
    "sources": [
      {
        "label": "Chron: Houston educator Shelby joins Hunt for Love",
        "url": "https://www.chron.com/neighborhood/culture/tv/article/90-day-tlc-cast-houston-20330923.php"
      },
      {
        "label": "TLC: Hunt for Love’s new singles",
        "url": "https://www.tlc.com/shows/90-day-hunt-for-love/meet-the-90-day-hunt-for-love-singles-retreat-hopefuls"
      },
      {
        "label": "Us Weekly: Hunt for Love’s retreat format",
        "url": "https://www.usmagazine.com/entertainment/news/90-day-hunt-for-love-sneak-peek-rob-finds-love-at-first-sight/"
      }
    ]
  },
  {
    "personId": "p-lexie-90-day-hunt-for-love-s1",
    "headline": "A new single who met Colt’s flirting practice without inheriting his entire relationship résumé.",
    "bio": [
      "Lexie joined Hunt for Love as one of the retreat’s new singles. TLC’s recap singled out her conversation with Colt during a flirting exercise: it began awkwardly, then became an enjoyable chat. Sometimes the icebreaker needs a second attempt.",
      "Colt later said he wished he had practiced with Cortney instead. That gives Lexie a specific moment in the show’s story, not an established romance with him; the flirting workshop did not automatically issue a couple certificate."
    ],
    "originStory": "Lexie’s franchise introduction came as a new participant at the Hunt for Love Season 1 retreat, including a filmed flirting exercise with Colt—not as his established partner.",
    "journeys": [
      {
        "label": "Where it started: joining the new singles",
        "era": "Hunt for Love S1",
        "summary": "Lexie entered the retreat independently. A short flirting conversation with Colt is documented, but the checked official source does not label them a couple."
      }
    ],
    "sources": [
      {
        "label": "TLC: Hunt for Love’s new singles",
        "url": "https://www.tlc.com/shows/90-day-hunt-for-love/meet-the-90-day-hunt-for-love-singles-retreat-hopefuls"
      },
      {
        "label": "TLC: Lexie and Colt’s flirting exercise",
        "url": "https://www.tlc.com/shows/90-day-hunt-for-love/90-day-hunt-for-love-drama-recap"
      }
    ]
  }
]

export const researchedTimelinesCFollowup: Record<string, CastProfileTimeline> = {
  "p-sierra-90-day-hunt-for-love-s1": {
    "connections": [],
    "seasons": [
      {
        "show": "90 Day: Hunt for Love",
        "season": 1,
        "title": "An independent retreat introduction",
        "recap": "Sierra was introduced among the new singles joining the Tulum retreat, rather than arriving with a returning couple storyline. A specific on-show match and post-retreat relationship outcome remain unverified.",
        "status": "aired"
      }
    ]
  },
  "p-shelby-90-day-hunt-for-love-s1": {
    "connections": [],
    "seasons": [
      {
        "show": "90 Day: Hunt for Love",
        "season": 1,
        "title": "A Houston educator joins the retreat",
        "recap": "Shelby entered the first season as one of the new singles meeting the franchise’s returning daters. Her educator background is independently reported, while a specific dating outcome remains unverified.",
        "status": "aired"
      }
    ]
  },
  "p-lexie-90-day-hunt-for-love-s1": {
    "connections": [
      {
        "name": "Colt Johnson",
        "personId": "p-colt-johnson",
        "context": "Her conversation partner during the retreat’s flirting exercise, not a verified boyfriend or romantic relationship."
      }
    ],
    "seasons": [
      {
        "show": "90 Day: Hunt for Love",
        "season": 1,
        "title": "A flirting exercise with Colt",
        "recap": "Lexie chatted with Colt during a flirting exercise, and TLC described their conversation improving after a rough start. Colt later said he wished he had paired with Cortney; the exercise is not evidence that he and Lexie dated.",
        "status": "aired",
        "partnerPersonIds": [
          "p-colt-johnson"
        ]
      }
    ]
  }
}
